/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { ptBR } from '@mui/material/locale';
import {
  createTheme,
  ThemeProvider,
  useTheme,
  Box,
  Tooltip,
  Button,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/pt-br';
import { get } from 'lodash';
import {
  FaEdit,
  FaWindowClose,
  FaExclamation,
  FaPrint,
  FaPaperclip,
  FaCircle,
} from 'react-icons/fa';
import {
  PiNumberCircleFive,
  PiNumberCircleFour,
  PiNumberCircleOne,
  PiNumberCircleThree,
  PiNumberCircleTwo,
} from 'react-icons/pi';
import AddIcon from '@mui/icons-material/Add';
import { toast } from 'react-toastify';
import { ContainerGrid, Title } from '../../styles/GlobalStyles';
import axios from '../../services/axios';
import Loading from '../../components/Loading';
import NumberFormatCustom from '../../utils/NumberFormatCustom';
import * as colors from '../../config/colors';
import RelatorioViagens from '../RelatorioViagem';

const textData = 'Controle de Viagens';
const tableRoute = 'viagem';
const tableData = 'viagens';

// Estilo para o modal

export default function Cadastro() {
  const [table, setTable] = useState([]);
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const navigate = useNavigate();

  const handleOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedId('');
  };
  const theme = useTheme();

  const getData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`/${tableData}`);
      setTable(response.data);
    } catch (err) {
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(`/home`);
    } finally {
      setIsLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    getData();
  }, [getData]);

  const handleDeleteAsk = (id) => {
    setDeleteConfirmId(id);
  };

  const handleDelete = async (e, id) => {
    e.persist();
    try {
      setIsLoading(true);
      if (id) {
        await axios.put(`/${tableData}/${id}`, {
          cancelamento: new Date(),
        });
        setIsLoading(false);
        toast.success('Registro cancelado com sucesso.');
      }
    } catch (err) {
      const status = get(err, 'response.status', 0);
      if (status === 401) {
        toast.error('Você precisa fazer login');
      } else {
        toast.error(`Ocorreu um erro ao cancelar registro.`);
      }
      setIsLoading(false);
    }
    getData();
  };
  const columns = useMemo(
    () => [
      {
        accessorKey: 'id',
        header: 'Nr.',
        size: 80,
      },
      {
        accessorKey: 'Motoristum.nome',
        header: 'Nome Motorista',
        size: 80,
      },
      {
        accessorKey: 'Veiculo.placa',
        accessorFn: (row) => row.Veiculo?.placa || null,
        header: 'Placa',
        size: 80,
      },
      {
        accessorKey: 'Carretum.placa',
        accessorFn: (row) => row.Carretum?.placa || null,
        header: 'Carreta',
        size: 80,
      },
      {
        accessorKey: 'descricao',
        header: 'Descrição',
        size: 80,
      },
      {
        accessorKey: 'saida',
        accessorFn: (row) =>
          row.saida ? moment(row.saida).format('DD/MM/YYYY') : null,
        header: 'Data Saída',
        size: 80,
      },
      {
        accessorKey: 'retorno',
        accessorFn: (row) =>
          row.retorno ? moment(row.retorno).format('DD/MM/YYYY') : null,
        header: 'Data Retorno',
        size: 80,
      },
      {
        accessorKey: 'kmsaida',
        accessorFn: (row) =>
          row.kmsaida ? (
            <NumberFormatCustom value={row.kmsaida} displayType="text" />
          ) : (
            ''
          ),
        muiTableHeadCellProps: { sx: { textAlign: 'right' } },
        header: 'Km Saída',
        size: 80,
      },
      {
        accessorKey: 'kmretorno',
        accessorFn: (row) =>
          row.kmretorno ? (
            <NumberFormatCustom value={row.kmretorno} displayType="text" />
          ) : (
            ''
          ),
        muiTableHeadCellProps: { sx: { textAlign: 'right' } },
        header: 'Km Retorno',
        size: 80,
      },
      {
        accessorKey: 'consumo',
        accessorFn: (row) =>
          row.consumo ? (
            <NumberFormatCustom value={row.consumo} displayType="text" />
          ) : (
            ''
          ),
        header: 'Consumo',
        size: 80,
      },
      {
        accessorKey: 'peso',
        accessorFn: (row) =>
          row.peso ? (
            <NumberFormatCustom value={row.peso} displayType="text" />
          ) : (
            ''
          ),
        header: 'Peso(T)',
        size: 80,
      },
      {
        accessorKey: 'Funcionario.nome',
        header: 'Nome Funcionário',
        size: 80,
      },
      {
        accessorKey: 'lancamento',
        accessorFn: (row) =>
          row.lancamento ? moment(row.lancamento).format('DD/MM/YYYY') : null,
        header: 'Data Lançamento',
        size: 80,
      },
      {
        accessorKey: 'flag_acerto',
        header: 'Acerto Motorista',
        accessorFn: (row) => (row.flag_acerto ? 'Sim' : 'Não'),
        size: 80,
      },
      {
        accessorKey: 'cancelamento',
        accessorFn: (row) =>
          row.cancelamento
            ? moment(row.cancelamento).format('DD/MM/YYYY')
            : null,
        header: 'Data Cancelamento',
        size: 80,
        muiTableHeadCellProps: { sx: { color: 'red' } },
        Cell: ({ renderedCellValue }) => (
          <strong style={{ color: 'red' }}>{renderedCellValue}</strong>
        ),
      },
    ],
    []
  );

  return (
    <ContainerGrid>
      <Loading isLoading={isLoading} />
      <Title>{`${textData}`}</Title>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          onClick={() => navigate(`/${tableRoute}`)}
        >
          <AddIcon size={24} />
        </Button>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          style={{ marginLeft: '5px' }}
          onClick={() => navigate(`/home`)}
        >
          Fechar
        </Button>
      </Box>
      <ThemeProvider theme={createTheme(theme, ptBR)}>
        <MaterialReactTable
          columns={columns}
          data={table}
          // enableColumnFilterModes
          enableColumnOrdering
          // enableEditing
          // enablePinning
          enableRowActions
          // enableRowSelection
          // enableSelectAll={false}
          initialState={{
            density: 'compact',
            showColumnFilters: false,
            showGlobalFilter: false,
          }}
          localization={MRT_Localization_PT_BR}
          renderRowActions={({ row }) => (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Tooltip arrow placement="left" title="Situação">
                <div>
                  {row.getValue('cancelamento') !== null ? (
                    // Condição 1: Se cancelamento for diferente de null (cor vermelha)
                    <PiNumberCircleFive
                      size={20}
                      style={{ background: '#FF0000' }}
                    /> // Vermelha
                  ) : row.getValue('saida') === null &&
                    row.getValue('retorno') === null &&
                    row.getValue('cancelamento') === null &&
                    row.getValue('flag_acerto') === 'Não' ? (
                    // Condição 2: Se saida for null, retorno for null e flag_acerto for 'Não' (cor verde)
                    <PiNumberCircleOne
                      size={20}
                      style={{ background: '#00FF00' }}
                    /> // Verde (ordem 2)
                  ) : row.getValue('saida') !== null &&
                    row.getValue('retorno') === null &&
                    row.getValue('cancelamento') === null &&
                    row.getValue('flag_acerto') === 'Não' ? (
                    // Condição 3: Se saida for diferente de null, retorno for null e flag_acerto for 'Não' (cor laranja)
                    <PiNumberCircleTwo
                      size={20}
                      style={{ background: '#FFA500' }}
                    /> // Laranja (ordem 3)
                  ) : row.getValue('retorno') !== null &&
                    row.getValue('saida') !== null &&
                    row.getValue('cancelamento') === null &&
                    row.getValue('flag_acerto') === 'Não' ? (
                    // Condição 4: Se retorno for diferente de null, saida for diferente de null e flag_acerto for 'Não' (cor amarelo)
                    <PiNumberCircleThree
                      size={20}
                      style={{ background: '#E33DD2' }}
                    /> // Rosa (ordem 1)
                  ) : row.getValue('retorno') !== null &&
                    row.getValue('saida') !== null &&
                    row.getValue('cancelamento') === null &&
                    row.getValue('flag_acerto') === 'Sim' ? (
                    // Condição 5: Se retorno for diferente de null, saida for diferente de null e flag_acerto for 'Sim' (cor azul)
                    <PiNumberCircleFour
                      size={20}
                      style={{ background: '#1E90FF' }}
                    /> // Azul claro (ordem 4)
                  ) : (
                    // Condição 6: Qualquer outra situação (cor preta)
                    <FaCircle size={20} style={{ background: '#000000' }} /> // Preto (default)
                  )}
                </div>
              </Tooltip>
              <Tooltip arrow placement="left" title="Lançamentos">
                <div>
                  {row.getValue('cancelamento') === null ? (
                    <Link
                      to={`/controleviagens/${row.getValue('id')}/lancamento`}
                    >
                      <FaPaperclip size={16} />
                    </Link>
                  ) : (
                    <span style={{ opacity: 0.5 }}>
                      <FaPaperclip size={16} />
                    </span>
                  )}
                </div>
              </Tooltip>
              <div>
                <Tooltip arrow placement="left" title="Imprimir">
                  <div>
                    <Link
                      component="button"
                      onClick={() => handleOpen(row.getValue('id'))}
                      style={{ cursor: 'pointer' }}
                    >
                      <FaPrint size={16} />
                    </Link>
                  </div>
                </Tooltip>

                {selectedId !== null && (
                  <RelatorioViagens
                    id={selectedId}
                    open={open}
                    onClose={handleClose}
                  />
                )}
              </div>
              <Tooltip arrow placement="left" title="Editar">
                <div>
                  {row.getValue('cancelamento') === null ? (
                    <Link to={`/${tableRoute}/${row.getValue('id')}/edit`}>
                      <FaEdit size={16} />
                    </Link>
                  ) : (
                    <span style={{ opacity: 0.5 }}>
                      <FaEdit size={16} />
                    </span>
                  )}
                </div>
              </Tooltip>
              <Tooltip arrow placement="right" title="Cancelar">
                {row.getValue('cancelamento') === null ? (
                  <div>
                    {deleteConfirmId === row.getValue('id') ? (
                      <FaExclamation
                        size={16}
                        color={colors.errorColor}
                        cursor="pointer"
                        onClick={(e) =>
                          handleDelete(e, row.getValue('id'), row.id)
                        }
                      />
                    ) : (
                      <FaWindowClose
                        size={16}
                        color={colors.primaryColor}
                        cursor="pointer"
                        onClick={() => handleDeleteAsk(row.getValue('id'))}
                      />
                    )}
                  </div>
                ) : (
                  <span style={{ opacity: 0.5 }}>
                    <FaWindowClose size={16} />
                  </span>
                )}
              </Tooltip>
            </Box>
          )}
        />
        <Box>
          <div style={{ margin: '20px 0' }}>
            <h3>Legenda de Cores</h3>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '8px',
              }}
            >
              <PiNumberCircleOne
                size={20}
                style={{ marginRight: '8px', background: '#00FF00' }}
              />
              <span>Viagem pendente de início</span>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '8px',
              }}
            >
              <PiNumberCircleTwo
                size={20}
                style={{ marginRight: '8px', background: '#FFA500' }}
              />
              <span>Viagem em andamento</span>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '8px',
              }}
            >
              <PiNumberCircleThree
                size={20}
                style={{ marginRight: '8px', background: '#E33DD2' }}
              />
              <span>Viagem finalizada, acerto pendente com o motorista</span>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '8px',
              }}
            >
              <PiNumberCircleFour
                size={20}
                style={{ marginRight: '8px', background: '#1E90FF' }}
              />
              <span>Viagem finalizada, acerto realizado com o motorista</span>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '8px',
              }}
            >
              <PiNumberCircleFive
                size={20}
                style={{ marginRight: '8px', background: '#FF0000' }}
              />
              <span>Viagem cancelada</span>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '8px',
              }}
            >
              <FaCircle
                size={20}
                style={{ marginRight: '8px', background: '#000000' }}
              />
              <span>Lançamento de viagem incorreta</span>
            </div>
          </div>
        </Box>
      </ThemeProvider>
    </ContainerGrid>
  );
}
